import React, { type FC, Fragment } from 'react';

import SlotStake from './SlotStake';

// ---

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyType = any;

type CorrectScoreProps = {
  [key: string]: AnyType;
  // TODO: write types, if you have some free time please :)
  // stakes: PropTypes.object.isRequired,
};

const CorrectScore: FC<CorrectScoreProps> = ({ stakes }) => {
  const firstTeamVictory: AnyType[] = [];
  const secondTeamVictory: AnyType[] = [];
  const draw: AnyType[] = [];

  stakes.forEach((stake: AnyType) => {
    const firstScore = stake.params.get('s1');
    const secondScore = stake.params.get('s2');

    if (firstScore > secondScore) {
      firstTeamVictory.push(stake);
    }
    else if (firstScore < secondScore) {
      secondTeamVictory.push(stake);
    }
    else {
      draw.push(stake);
    }
  });

  // TODO: сортировку кэшировать через useMemo
  // Если будете в этом файле, не игнорируйте этот TODO, пожалуйста
  return (
    <Fragment>
      <CorrectScoreStakes stakes={
        firstTeamVictory.sort((a, b) => {
          const diff = a.params.get('s1') - b.params.get('s1');

          if (diff === 0) {
            return a.params.get('s2') - b.params.get('s2');
          }

          return diff;
        })} />
      <CorrectScoreStakes stakes={
        draw.sort((a, b) => (
          a.params.get('s1') - b.params.get('s1')),
        )} />
      <CorrectScoreStakes stakes={
        secondTeamVictory.sort((a, b) => {
          const diff = a.params.get('s2') - b.params.get('s2');

          if (diff === 0) {
            return a.params.get('s1') - b.params.get('s1');
          }

          return diff;
        })} />
    </Fragment>
  );
};

function CorrectScoreStakes({ stakes }: CorrectScoreProps) {
  return (
    stakes.map((stake: AnyType) => (
      <SlotStake stake={stake}
                 key={stake.id} />
    ))
  );
}

export default CorrectScore;
